exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-page>.btn.btn-sign-out.btn-lg[data-v-f6a10e0a]{margin-top:25px;margin-bottom:16px}", ""]);

// exports
